module.exports = __webpack_public_path__ + "media/images/avatar_female-81cf55ce4efb93594e6f222499b5da53.png";